import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 切换动画和列表
    isShowView: JSON.parse(localStorage.getItem('isShowView')) || true,
    logo: localStorage.getItem('logo'),
    navTitle: '',
    regionLength: 0,
    cesiumLoad:false
  },
  mutations:{
    // menu上方title
    NAV_TITLE(state, name){
      state.navTitle = name == 'HOME' ? '' : name
    },
    // 区域数据
    REGION_LENGTH(state, name){
      state.regionLength = name
    }
  }
})
